export const trackGA4Event = (event, params) => {
    if (window.gtag) {
        window.gtag('event', event, params);
    }
};

export const trackGoogleAdsConversion = (url) => {
    if (window.gtag) {
        var callback = function () {
            if (typeof url != 'undefined') {
                window.location = url;
            }
        };
        window.gtag('event', 'conversion', {
            send_to: 'AW-971710399/dtcJCKSbg-QBEL-_rM8D',
            event_callback: callback
        });
        return false;
    }
};

export const trackGoogleAdsUngatedContentDownloadConversion = (url) => {
    if (window.gtag) {
        var callback = function () {
            if (typeof url != 'undefined') {
                window.location = url;
            }
        };
        window.gtag('event', 'conversion', {
            send_to: 'AW-971710399/LDclCLzX6foBEL-_rM8D',
            event_callback: callback
        });
        return false;
    }
};

export const trackGoogleAdsContentDownloadConversion = (url) => {
    if (window.gtag) {
        var callback = function () {
            if (typeof url != 'undefined') {
                window.location = url;
            }
        };
        window.gtag('event', 'conversion', {
            send_to: 'AW-971710399/BU8_CPuM8uMBEL-_rM8D',
            event_callback: callback
        });
        return false;
    }
};